import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import Coordinates from "../components/Coordinates";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import ABPlayer from "../components/sections/ABPlayer";
import Gear from "../components/sections/Gear";
import Contact from "../components/sections/Contact";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-white text-black">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <ABPlayer />
        <Gear />
        <Contact />
      </main>
      <Coordinates />
      <Footer />
    </div>
  );
}
